import { SiteDown } from "components/AppendixScreen/SiteDown";
import { handleHardstopHeaderText, handleHardstopTopText } from "util/hardStop";
import { CommonHardStop } from "components/AppendixScreen/CommonHardStop";
import { AppError, ErrorType } from "domain/error";
import { Store } from "state/store";
import { UnAuthSigHardstop } from "components/AppendixScreen/UnAuthSigHardstop";
import { NoPaygHardstop } from "components/AppendixScreen/NoPaygHardstop";
import { ComprehensionHardstop } from "components/AppendixScreen/ComprehensionHardstop";
import { FinDifficultyHardstop } from "components/AppendixScreen/FinDifficultyHardstop";
import { APPENDIX_SCREEN_TITLE } from "./Title.const";

export type AppendixScreenProps = {
  store: Store;
};

export const AppendixScreen = ({ store }: AppendixScreenProps) => {
  document.title = APPENDIX_SCREEN_TITLE;
  const { assertionsStore, attestationStore } = store;
  const applicationError =
    assertionsStore.applicationError || attestationStore.applicationError;

  const renderHardstop = (errorType: ErrorType) => {
    switch (errorType) {
      case ErrorType.ClsNoToPayg:
        return <NoPaygHardstop />;
      case ErrorType.ClsUnAuthSig:
        return <UnAuthSigHardstop />;
      case ErrorType.ClsVulnerable:
      case ErrorType.ClsCeasedTrading:
        return (
          <CommonHardStop
            headerText={handleHardstopHeaderText(errorType)}
            toptext={handleHardstopTopText(errorType)}
            errorType={errorType}
          />
        );
      case ErrorType.ClsComprehension:
        return <ComprehensionHardstop />;
      case ErrorType.ClsFinDiffBBB:
      case ErrorType.ClsFinDiffFCA:
        return <FinDifficultyHardstop />;
      default:
        return <SiteDown />;
    }
  };
  switch (applicationError?.type) {
    case AppError.HardStop:
      return renderHardstop(applicationError.payload.errorType[0]);
    case AppError.Generic:
    default:
      return <SiteDown />;
  }
};
